import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IrisService } from '../shared/iris.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-info-dashboard',
  templateUrl: './info-dashboard.component.html',
  styleUrls: ['./info-dashboard.component.scss']
})
export class InfoDashboardComponent implements OnInit {
  buttonLabel = "info.search_btn";
  placeholder = "info.placeholder";
  noSelected = "info.no_selected";
  titleColor: string;
  informations: any[];
  prefecture: any[];
  pref: string = '全国';

  constructor(
    private translate: TranslateService,
    private irisSrv: IrisService,
    private router: Router,

  ) {
    console.log('info-dashboard constructor');
    this.irisSrv.resetIndex();
  }

  ngOnInit() {
    this.prefecture = environment.places;
    this.informations = environment.facilities;
    this.titleColor = environment.tiles[0].color;
  }

  IsMobile() {
    let ua = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf('iphone') !== -1) {
      return true;
    } else if (ua.indexOf('ipad') !== -1) {
      return true;
    } else if (ua.indexOf('android') !== -1) {
      return true;
    }
    return false;
  }

  public onClick() {
    let options: string[] = [];
    for (let i = 0; i < this.informations.length; i++) {
      if (this.informations[i].checked) {
        options.push(this.informations[i].tag);
      }
    }
    options.push(this.pref);
    console.log(options);

    let noTag: boolean = true;
    for (const o of options) {
      if (o.includes('tag')) {
        noTag = false;
        break;
      }
    }
    if (noTag) {
      alert('知りたい項目にチェックをつけてください');
      return;
    }

    this.irisSrv.activeRoot();
    this.router.navigate(['searchedboard'], { queryParams: { type: 'search.type_info', options:  options.toString() } });
  }

}
